import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WarningsService {

  public warnings = ['no_columns', 'no_data', 'too_long', 'too_big'];

  public getRowsPerDay(granularity) {
    let rpd = 0;
    parseInt(granularity, 10) === 0 ? rpd = 144 :  // 10 minutes data
    parseInt(granularity, 10) === 1 ? rpd = 24 :  // 1 hour data
    // parseInt(granularity, 10) === 2 ? rpd = 1 :  // 1 day
    parseInt(granularity, 10) === 2 ? rpd = 1 / 30 :  // 1 month
    parseInt(granularity, 10) === 3 ? rpd = 1 / 365 : // 1 year
    // parseInt(granularity, 10) === 5 ? rpd = 24 * 60 * 2 : // 30 second data
                null;
    return rpd;
  }

  public getRowsNumber(granularity, days) {
    return (Math.round(this.getRowsPerDay(granularity) * days));
  }

  public getFieldsNumber(granularity, columns, days) {
    return (columns * this.getRowsNumber(granularity, days));
  }

  public getDays(tsBegin, tsEnd) {
    return (Math.floor((tsEnd - tsBegin) / (24 * 60 * 60 * 1000)) + 1);
  }

  public getFileSize(fields) {
    return (28.55 * fields + 15500) / 1024;
  }

  public selectedFieldsCount(selected: Array<boolean>) {
    let a = 0;
    selected.map(b => b === true ? a++ : null);
    return a;
  }

  checkWarn(alarm, parameter): string {
    let alarmText = 'alarm code unknown';
    switch (alarm) {
      case 'tooLong':
        parameter > 200000 ? alarmText = 'There are too many rows. The application may become unresponsive or even freeze' : alarmText = '';
        break;
      case 'noData':
        parameter === 0 ? alarmText = 'No data was returned from the server. Maybe there is no data for the selected time period.' : alarmText = '';
        break;
      case 'noAlarms':
        parameter === 0 ? alarmText = 'No Alarms were returned from the server. Maybe there are none for the selected time period.' : alarmText = '';
        break;
      case 'tooBig':
        parameter > 100000 ? alarmText = 'File size is too big.There could be problems creating the excel file. Try exporting to CSV instead.' : alarmText = '';
        break;
      case 'noColumns':
        parameter === 0 ? alarmText = 'No columns have been selected. Please select the columns you need.' : alarmText = '';
        break;
      case 'thirtySMax':
        parameter > 31 ? alarmText = 'You have selected more than 31 days, that is the maximum period allowed for 30 seconds data.' : alarmText = '';
        break;
        case 'maxFileSize':
          parameter > 50000 ? alarmText = 'You have already more than 50 mb stored in the server. Delete some files before creating a new one.' : alarmText = '';
    }
    return alarmText;
  }

  getAlarmsWarnings(): any {
    const alarmList = [];
  }
}
